import { api } from '@/services/axios'

export interface ICreatePromocao {
  quantidade: number
  valor: number
  campanha_Id: number
}

export interface IPromocao extends ICreatePromocao {
  id: number
}

export async function createPromocao(data: ICreatePromocao) {
  const response = await api.post('CampanhaPromocao/Create', {
    ...data,
    valor: data.valor.toString(),
  })
  return response.data
}

export async function getPromocaoById(id: number) {
  const response = await api.get(`CampanhaPromocao/GetById/${id}`)
  return response.data
}

export async function deletePromocao(id: number) {
  const response = await api.delete(`CampanhaPromocao/Delete/${id}`)
  return response.data
}

export async function updatePromocao(id: number, data: ICreatePromocao) {
  const response = await api.put(`CampanhaPromocao/Update/${id}`, {
    ...data,
    valor: data.valor.toString(),
  })
  return response.data
}

export async function getAllPromocoes(campanhaId: number) {
  const response = await api.get(`CampanhaPromocao/GetAll`, {
    params: { campanhaId },
  })
  return response.data
}
